import http from '@/libs/axios'

export function createRole(data) {
  return http({
    method: 'POST',
    url: '/users/roles/',
    data,
  })
}

export function getRole(params) {
  return http({
    method: 'GET',
    url: '/users/roles/',
    params,
  })
}

export function getRoleList(params) {
  return http({
    method: 'GET',
    url: '/users/groups/',
    params,
  })
}

export function updateRole({
  data,
  id,
}) {
  return http({
    method: 'PATCH',
    url: `/users/roles/${id}/`,
    data,
  })
}

export function deleteRole(id) {
  return http({
    method: 'DELETE',
    url: `/users/roles/${id}/`,
  })
}
